import { USER_EVENTS } from '@shared/core/user-events'
import { useCallback } from 'react'
import { useAddUserEvent } from 'src/modules/user-events/use-add-event'
import { markKalamaRenamedPopupShownInTab } from './kalama-renamed-modal.domain'

export type RecordKalamaRenamedPopupSeen = (accountId: string) => void

// Tab cap first: a failed post rolls the optimistic row back, and only the cap then keeps the popup away.
export function useRecordKalamaRenamedPopupSeen(): RecordKalamaRenamedPopupSeen {
  const addUserEvent = useAddUserEvent()

  return useCallback<RecordKalamaRenamedPopupSeen>(
    (accountId) => {
      markKalamaRenamedPopupShownInTab(accountId)
      addUserEvent.mutate({ eventName: USER_EVENTS.KALAMA_RENAMED_WEB_POPUP_SEEN, once: true })
    },
    [addUserEvent],
  )
}
